module.exports = "/assets/images/bus_bc51f4.svg";